import { User } from 'app/models';

export function checkScenicPermissions(
  currentUser: User,
  videoInformations: any
): boolean {
  if (!currentUser || !videoInformations) return false;
  if (currentUser.id === videoInformations.author.id || currentUser.is_admin)
    return true;
  return false;
}
